import React from 'react'
import PropTypes from 'prop-types'
import { Badge } from 'reactstrap'
import StringUtil from 'utils/string-util'

const propTypes = {
  /** color of the badge. available colors */
  color: PropTypes.string.isRequired,

  /** label of the status */
  label: PropTypes.string.isRequired
}

const defaultProps = {
  color : 'primary',
  label : 'channel'
}

/**
 *  @param {string} colour - colour of the badge
 *  @param {string} label - text inside the badge
 */
const NotificationChannelBadge = ({
  color,
  label,
  ...props
}) => (
  <Badge
    { ...props }
    color={ color }
  >
    { StringUtil.humanizeUpperCase(label) }
  </Badge>
)

NotificationChannelBadge.propTypes    = propTypes
NotificationChannelBadge.defaultProps = defaultProps

export default NotificationChannelBadge
